export default __webpack_public_path__ + "static/media/webassembly.892c03a5.svg";